<template>
  <div class="inventory_wrapper public-content">
    <div class="flex_wrapper">
      <div class="inventory_wrapper-title">每日盘点</div>
      <div class="inventory_wrapper-form">
        <!-- 账户 -->
        <el-select
          placeholder="请选择"
          size="small"
          @change="accountChange"
          multiple
          clearable
          class="inventory_wrapper-form-accAount"
          collapse-tags
          v-model="formData.fkJournalAccountIds"
          :clearable="false"
          filterable
        >
          <el-option v-for="(item,index) in allAccountList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- 日期范围  选择月-->
        <el-date-picker
          v-model="dateList"
          type="monthrange"
          range-separator="至"
          size='small'
          :clearable="false"
          v-show="!isYearDateRang"
          class="inventory_wrapper-form-date"
          value-format="yyyy-MM" format="yyyy年MM月"
          start-placeholder="开始月份"
          @change='getDataChange'
          end-placeholder="结束月份">
        </el-date-picker>
        <!-- 日期范围  选择年-->
        <el-date-picker
          size='small'
           :clearable="false"
           class="inventory_wrapper-form-date"
          v-model="yearDate"
          value-format="yyyy"
          format="yyyy年"
          @change='getDataChange'
          v-show="isYearDateRang"
          type="year"
          placeholder="选择年">
        </el-date-picker>
        <!-- 筛选条件 censusType -->
        <el-radio-group v-model="formData.censusType" @change="handleRadioChange">
          <el-radio :label="0">按日统计</el-radio>
          <el-radio :label="1">按月统计</el-radio>
          <el-radio :label="2">按季统计</el-radio>
          <el-radio :label="3">按年统计</el-radio>
        </el-radio-group>
      </div>
      <!-- 按钮 -->
      <div class="inventory_wrapper-btn">
        <accBtn
          :text="i.name"
          type="5"
          @click="handleOperation(i)"
          width="60px"
          v-for="i in buttonList"
          :key="i.id"
        >
        </accBtn>
      </div>
    </div> 
    <!-- 表格 -->
    <div class="inventory_wrapper-tableList">
      <public-table  :table="tableData" @onHandlePaginationChange="handlePaginationChange">
        <!-- 核对账户  -->
        <template slot-scope="props" slot="accountName">
          <span class="inventory_wrapper-tableList-textLeft">
            <span :class = "{ 'bold':props.scope.row.total }">{{props.scope.row.accountName}}</span>
            <el-popover
              placement="bottom-right"
              title="修改数据"
              width="900"
              trigger="click"
            >
              <edit-table :ref="props.scope.row.models"></edit-table>
              <span
                class="inventory_wrapper-tableList-editIcon"
                slot="reference"
                @click="getEditTable(props.scope.row)"
                v-if="props.scope.row.update">
                  改
              </span>
            </el-popover>
          </span>
        </template>
        <!-- 盘点日收入 -->
        <template slot-scope="props" slot="debitMoney">
          <span class="inventory_wrapper-tableList-textRight">
            {{ currencys(props.scope.row.debitMoney) }}
          </span>
        </template>
        <!-- 盘点日余额 -->
        <template slot-scope="props" slot="remainingSum">
          <span class="inventory_wrapper-tableList-textRight">
            {{ currencys(props.scope.row.remainingSum) }}
          </span>
        </template>
        <!-- 盘点日支出 -->
        <template slot-scope="props" slot="creditorMoney">
          <span class="inventory_wrapper-tableList-textRight">
            {{ currencys(props.scope.row.creditorMoney) }}
          </span>
        </template>
        <!-- 收入差额 -->
        <template slot-scope="props" slot="debitMoneyDifference">
          <span
            :style="getDataStyle(props.scope.row.debitMoneyDifference)"
            v-show="props.scope.row.debitMoneyDifference"
            class="inventory_wrapper-tableList-textRight"
          >
            {{ currencys(props.scope.row.debitMoneyDifference) }}
          </span>
        </template>
        <!-- 支出差额 -->
        <template slot-scope="props" slot="creditorMoneyDifference">
          <span
            :style="getDataStyle(props.scope.row.creditorMoneyDifference)"
            v-show="props.scope.row.creditorMoneyDifference"
            class="inventory_wrapper-tableList-textRight"
          >
            {{ currencys(props.scope.row.creditorMoneyDifference) }}
          </span>
        </template>
        <!-- 余额差额 -->
        <template slot-scope="props" slot="remainingSumDifference">
          <span
            :style="getDataStyle(props.scope.row.remainingSumDifference)"
            class="inventory_wrapper-tableList-textRight"
            v-show="props.scope.row.remainingSumDifference">
            {{ currencys(props.scope.row.remainingSumDifference) }}
          </span>
        </template>
        <!-- 实际收入 -->
        <template slot-scope="props" slot="actualDebitMoney">
          <div>
            <el-input
              v-model="props.scope.row.actualDebitMoney"
              size="mini"
              clearable
              :ref="'actualDebitMoneyRef' + props.scope.row.uId"
              @focus="handleFocus($event,'actualDebitMoneyRef' + props.scope.row.uId)"
              @input="inputChange($event,props.scope.row)"
              v-show="props.scope.row.isEdit"
              placeholder="请输入"
            >
            </el-input>
            <span
              v-show="!props.scope.row.isEdit"
              class="inventory_wrapper-tableList-textRight"
            >
                {{ props.scope.row.actualDebitMoney === 0?'0.00':currencys(props.scope.row.actualDebitMoney) }}
            </span>
          </div>
        </template>
        <!-- 实际支出 -->
        <template slot-scope="props" slot="actualCreditorMoney">
          <div>
            <el-input
              v-model="props.scope.row.actualCreditorMoney"
              size="mini"
              :ref="'actualCreditorMoney' + props.scope.row.uId"
              @focus="handleFocus($event,'actualCreditorMoney' + props.scope.row.uId)"
              clearable
              @input="inputChange($event,props.scope.row)"
              v-show="props.scope.row.isEdit"
              placeholder="请输入"
            >
            </el-input>
            <span
              v-show="!props.scope.row.isEdit"
              class="inventory_wrapper-tableList-textRight"
            >
              {{ props.scope.row.actualCreditorMoney === 0?'0.00':currencys(props.scope.row.actualCreditorMoney) }}
            </span>
          </div>
        </template>
        <!-- 实际余额 -->
        <template slot-scope="props" slot="actualRemainingSum">
          <div>
            <el-input
              v-model="props.scope.row.actualRemainingSum"
              size="mini"
              :ref="'actualRemainingSum' + props.scope.row.uId"
              @focus="handleFocus($event,'actualRemainingSum' + props.scope.row.uId)"
              @input="inputChange($event,props.scope.row)"
              clearable
              v-show="props.scope.row.isEdit"
              placeholder="请输入"
            >
            </el-input>
            <span
              v-show="!props.scope.row.isEdit"
              class="inventory_wrapper-tableList-textRight"
            >
              {{ props.scope.row.actualRemainingSum === 0?'0.00':currencys(props.scope.row.actualRemainingSum) }}
            </span>
          </div>
        </template>
        <!-- 差额原因 -->
        <template slot-scope="props" slot="differenceReason">
          <div>
            <el-input
              v-model="props.scope.row.differenceReason"
              size="mini"
              :maxlength="50"
              :ref="'differenceReason' + props.scope.row.uId"
              @focus="handleFocus($event,'differenceReason' + props.scope.row.uId)"
              clearable
              v-show="props.scope.row.isEdit"
              placeholder="请输入"
            >
            </el-input>
            <span v-show="!props.scope.row.isEdit" class="inventory_wrapper-tableList-textLeft">{{ props.scope.row.differenceReason }}</span>
          </div>
        </template>
        <!-- 操作 -->
        <template slot-scope="props" slot="operation">
        	<div class="inventory_wrapper-tableList-operation" v-if="isHaveEdit && props.scope.row.isHaveEdit">
            <span
              v-if="!props.scope.row.isEdit"
              class="inventory_wrapper-tableList-operation-edit"
              @click="editRow(props.scope.row,true)"
            >
              编辑
            </span>
            <template v-else>
              <span @click="editRow(props.scope.row,false)" class="inventory_wrapper-tableList-operation-cancal">取消</span>
              <span class="inventory_wrapper-tableList-operation-save" @click="saveRow(props.scope.row)">保存</span>
            </template>
          </div>
        </template>
      </public-table>
    </div>
  </div>
</template>

<script>
  import publicTable from '@/components/publicTable'
  import {currencys} from '@/assets/utils/currencyFormat'
  import editTable from "./components/inventory/editTable.vue"
  export default {
    components:{
      publicTable,
      editTable
    },
    data() {
      return {
        currencys,
        isHaveEdit:true,  // 是否有编辑按钮
        buttonList:[],
        nowClickRow:{},
        isYearDateRang:false,  // 是否切换年日期组件
        debounceTime:null,  // 处理计算的防抖计时器
        tableListGroup:[],  // 装表格数据组的二维数组
        allAccountList:[],
        dateList:[new Date(),new Date()], // 日、月统计
        yearDate:new Date(),  // 季度、年统计
        formData:{
          fkJournalAccountIds:[],
          censusType: 0, //统计类别
          start:"", // 开始时间 yyyy-MM 或者 yyyy
          end:"", // 结束时间 yyyy-MM 或者 yyyy
          currentPage:1, // 页码
          maxResult:10, // 条数
        },
        tableData: {
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
          height:"600px",
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,		// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	hasShowPagination: true,	// 是否显示分页
        	config: [{
        		label: '盘点对象',
        		value: 'obj',
        		show: 'normal',
            showChild:true,
            children:[
                {
                  label: '日期',
                  value: 'date',
                  show: 'normal',
                },
                {
                  label: '核对账户',
                  value: 'accountName',
                  show: 'template',
                }
              ]
            },{
              label: '日记账统计',
              value: 'tj',
              show: 'normal',
              showChild:true,
              children:[
                  {
                    label: '盘点日收入',
                    value: 'debitMoney',
                    show: 'template',
                  },
                  {
                    label: '盘点日支出',
                    value: 'creditorMoney',
                    show: 'template',
                  },
                  {
                    label: '盘点日余额',
                    value: 'remainingSum',
                    show: 'template',
                  }
                ]
            },
            {
              label: '实际账面金额（请填写）',
              value: 'sd',
              show: 'normal',
              showChild:true,
              children:[
                  {
                    label: '实际收入',
                    value: 'actualDebitMoney',
                    show: 'template',
                  },
                  {
                    label: '实际支出',
                    value: 'actualCreditorMoney',
                    show: 'template',
                  },
                  {
                    label: '实际余额',
                    value: 'actualRemainingSum',
                    show: 'template',
                  }
                ]
            },
            {
              label: '差额',
              value: 'sds',
              show: 'normal',
              showChild:true,
              children:[
                  {
                    label: '收入差额',
                    value: 'debitMoneyDifference',
                    show: 'template',
                  },
                  {
                    label: '支出差额',
                    value: 'creditorMoneyDifference',
                    show: 'template',
                  },
                  {
                    label: '余额差额',
                    value: 'remainingSumDifference',
                    show: 'template',
                  },
                  {
                    label: '差额原因',
                    value: 'differenceReason',
                    show: 'template',
                  }
                ]
            },
            {
              label: '盘点人',
              value: 'inventoryUser',
              show: 'normal',
            },
            {
              label: '操作',
              value: 'operation',
              show: 'template',
            }

          ],
        	data: [],
        	page: {
        		pageNo: 1,
        		pageSize: 10,
        		count: 0
        	},
        	center: {
        		textAlign: 'center',
        		padding: '6px 0'
        	},
          arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
          tableRowClassName: this.tableRowClassName
        },
      }
    },
    created() {
      // 给时间赋值
      let date = new Date();
      this.formData.start = this.$formart(date,'yyyy-MM')
      this.formData.end = this.$formart(date,'yyyy-MM')
      this.getAllAccount();
      this.getButtonList();
    },
    mounted() {
      this.$nextTick(()=>{
        this.getTableheight();
      })
      window.addEventListener("resize",()=>{
        this.getTableheight();
      })
    },
    deactivated() {
      window.removeEventListener("resize",()=>{})
    },
    methods:{
      // 行样式
      tableRowClassName({row, column, rowIndex, columnIndex}) {
       if(row.total) {
         return "i-tableRow-total"
       }
      },
      // 获取修改表格
      getEditTable(row) {
        // this.nowClickRow = row;
        this.$nextTick(()=>{
          this.$refs[row.models].getTable(row);
        })
      },
      // 打印 && 导出
      handleOperation(item) {
        if(item.permission === "ac:inventory:print") {  // 打印
          this.printTable(item);
        }else if(item.permission === "ac:inventory:import") { // 导出
          this.printImport(item);
        }
      },
      // 打印
      printTable(item) {
        let params =  {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          ...this.formData
        }
        const router = this.$router.resolve({
        	path: '/journal/printInventory',
        	query: params
        })
        window.open(this.$rootUrl + router.href, '_blank')
      },
      // 导出
      printImport(item) {
        let params =  {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          ...this.formData
        }
        const router = this.$router.resolve({
        	path: '/journal/exportInventory',
        	query: params
        })
        window.location.href = this.$rootUrl + router.href;
      },
      // 获取打印导出导入按钮权限
      getButtonList() {
        const _ = this;
        let params={
          permissions:'ac:inventory:import,ac:inventory:print'
        }
         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
            if(res && res.data.code == 1) {
              _.buttonList = res.data.data;
            }
         })
      },
      // 聚焦选中文本
      handleFocus(e,ref) {
        this.$refs[ref].select();
      },
      // 表格保存行
      saveRow(row) {
        this.tableData.loading = true;
        this.$http.post('journal/saveActualBookAmount',row).then(res=>{
          this.tableData.loading = false;
          if(res && res.data.code == '1'){
            this.$message.success("保存成功！");
            row.actualDebitMoney_copy = row.actualDebitMoney;
            row.actualCreditorMoney_copy = row.actualCreditorMoney;
            row.actualRemainingSum_copy = row.actualRemainingSum;
            row.differenceReason_copy = row.differenceReason;
            row.isEdit = false;
            this.getTableData();
          }
        }).catch(e=>{

        });
      },
      // 统计方式改变
      handleRadioChange(e) {
        this.isHaveEdit = e === 0;
        this.isYearDateRang = e > 1;
        if(this.isYearDateRang) {
          this.formData.start = this.$formart(this.yearDate,"yyyy");
          this.formData.end = this.$formart(this.yearDate,"yyyy");
        }else {
          this.formData.start = this.$formart(this.dateList[0],"yyyy-MM");
          this.formData.end = this.$formart(this.dateList[1],"yyyy-MM");
        }
        this.getTableData();
      },
      // 动态获取表格高度
      getTableheight() {
        let domHeight = document.getElementsByClassName("inventory_wrapper-tableList")[0].clientHeight;
        this.tableData.height = domHeight - 50 + "px";
      },
      // 翻页
      handlePaginationChange (data) {
      	const { pageNo, pageSize } = data;

      	if (pageNo) {
      		this.$set(this.formData, 'currentPage', pageNo);
      		this.$set(this.tableData.page, 'pageNo', pageNo);
      	}

      	if (pageSize) {
      		this.$set(this.formData, 'maxResult', pageSize);
      		this.$set(this.tableData.page, 'pageSize', pageSize);
      	}
      	this.getTableData();
      },
      // 获取每日盘点表格数据
      getTableData() {
        this.tableData.loading = true;
        this.tableData.page.count = 0;
        this.tableData.data = [];
        this.$http.post('journal/inventory',this.formData).then(res=>{
          this.tableData.loading = false;
          if(res && res.data.code == '1'){
            if(res.data.data.list.length) {
              let list = res.data.data.list;
              list.map(i=>{
                i.isEdit = false;
                i.isHaveEdit = true;
                i.debitMoneyDifference = "";
                i.creditorMoneyDifference = "";
                i.remainingSumDifference = "";
                i.remainingSum = i.remainingSum.toFixed(2);
                i.debitMoney = i.debitMoney.toFixed(2);
                i.creditorMoney = i.creditorMoney.toFixed(2);
                i.models = "model_" + i.uId;
                i = this.copyRow(i);
                if(i.id) {
                  this.rowDifference(i);  // 计算差额
                }
                return i;
              });
              this.tableData.page.count = parseInt(res.data.data.total);
              this.mergeComputed(list);
            }
          }
        }).catch(e=>{

        });
      },
      // 赋值一条当前行的数据 用于修改取消之后恢复数据
      copyRow(row) {
        for(var i in row) {
          let label = i + "_copy";
          row[label] = row[i];
        }
        return row;
      },
      // 表格合并计算
      arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      	if (columnIndex === 0) {
      		if (row.rows) {
      			return {
      				rowspan: row.rows,
      				colspan: 1
      			}
      		} else {
      			return {
      				rowspan: 0,
      				colspan: 0
      			}
      		}
      	}
      },
      // 合并数据处理
      mergeComputed(arr) {
        let data = this.$lodash.cloneDeep(arr);
        this.tableListGroup = [];
        if(data&&data.length) {
          let arr = [] , num = 0 , date = data[0].date;
          data.forEach((i,index)=>{
            if(i.date === date) {
              arr.push(i);
            }else {
              arr = [],
              arr.push(i);
              num = index;
              date = data[num].date;
            }
            if(i.total) {
              this.totalComputed(arr);
              i.isHaveEdit = false;
              this.tableListGroup.push(arr);
            }
            data[num].rows=arr.length;
          })
        }else {
          throw new Error("未检测到合并处理数据！！！")
        }
        this.tableData.data = data;
      },
      // 动态计算 总账合计 @arrs 传入当前修改日期计算数组
      totalComputed(arrs) {
        let arr = this.$lodash.cloneDeep(arrs);
        if(arr && arr.length) {
          let totalRow = arrs[arrs.length-1];
          let lastArr = arr.pop();
          // 置空合计行
          totalRow.debitMoney = "";
          totalRow.creditorMoney = "";
          totalRow.remainingSum = "";
          totalRow.actualDebitMoney = "";
          totalRow.actualCreditorMoney = "";
          totalRow.actualRemainingSum = "";
          totalRow.debitMoneyDifference = "";
          totalRow.creditorMoneyDifference = "";
          totalRow.remainingSumDifference = "";
          if(arr.length === 0) {  // 数组只有一个账户  那么账户的值就是总值
            totalRow = lastArr;
          }else {  // 一个以上得用加法
            let step = 10000;
            arr.forEach(i=>{
              totalRow.debitMoney = ((totalRow.debitMoney*step) + (i.debitMoney*step))/step;
              totalRow.creditorMoney = ((totalRow.creditorMoney*step) + (i.creditorMoney*step))/step;
              totalRow.remainingSum = ((totalRow.remainingSum*step) + (i.remainingSum*step))/step;

              totalRow.actualDebitMoney = ((totalRow.actualDebitMoney*step) + (i.actualDebitMoney*step))/step || "";
              totalRow.actualCreditorMoney = ((totalRow.actualCreditorMoney*step) + (i.actualCreditorMoney*step))/step || "";
              totalRow.actualRemainingSum = ((totalRow.actualRemainingSum*step) + (i.actualRemainingSum*step))/step || "";

              totalRow.debitMoneyDifference = ((totalRow.debitMoneyDifference*step) + (i.debitMoneyDifference*step))/step;
              totalRow.creditorMoneyDifference = ((totalRow.creditorMoneyDifference*step) + (i.creditorMoneyDifference*step))/step;
              totalRow.remainingSumDifference = ((totalRow.remainingSumDifference*step) + (i.remainingSumDifference*step))/step;
            })

          }
        }else {
          throw new Error("未检测到计算数据！！！")
        }
      },
      // 动态计算 差额&&总账合计
      inputChange(e,row) {
        if(this.debounceTime) {
          clearTimeout(this.debounceTime)
        }
        this.debounceTime = setTimeout(()=>{
          this.rowDifference(row);
          this.getTableListGroup(row.uId)
        },500)
      },
      // 计算行的差额
      rowDifference(row) {
        let step = 10000;
        row.debitMoneyDifference =  (row.actualDebitMoney !== "" && row.actualDebitMoney !== null)?((row.actualDebitMoney*step) - (row.debitMoney*step)) /step:0;
        row.creditorMoneyDifference = (row.actualCreditorMoney !== "" && row.actualCreditorMoney !== null)?((row.actualCreditorMoney*step) - (row.creditorMoney*step))/step:0;
        row.remainingSumDifference = (row.actualRemainingSum !== "" && row.actualRemainingSum !== null)?((row.actualRemainingSum*step) - (row.remainingSum*step))/step:0;
      },
      // 计算列的总账合计
      getTableListGroup(uId) {
        let arrList = this.tableListGroup,arrListIndex=[];
        a:for(var i=0;i<arrList.length;i++) {
          b:for(var j=0;j<arrList[i].length;j++) {
            if(arrList[i][j].uId === uId) {
              arrListIndex = arrList[i];
              break a;
            }
          }
        }
        this.totalComputed(arrListIndex);
      },
      // 返回样式
      getDataStyle(number) {
        let num = Number(number);
        let styles = {
          color:""
        }
        if(num === 0) {
          styles.color = "#333333"
        }else {
          styles.color = "#FF4040"
        }
        return styles;
      },
      // 编辑 && 取消
      editRow(row,Bool) {  // Bool为true时编辑判断  只能有一行处于编辑状态
        let data = this.tableData.data;
        let isHaveEdit = data.some(i=>{ return i.isEdit })
        if(Bool) {  // 编辑时
          if(isHaveEdit) {
            this.$message.warning("您当前有正在修改的盘点项！")
          }else {
            row.isEdit = Bool;
          }
        }else {  // 恢复修改的数据
          row.actualDebitMoney = row.actualDebitMoney_copy;
          row.actualCreditorMoney = row.actualCreditorMoney_copy;
          row.actualRemainingSum = row.actualRemainingSum_copy;
          row.differenceReason = row.differenceReason_copy;
          row.isEdit = Bool;
          this.rowDifference(row);
          this.getTableListGroup(row.uId)
        }

      },
      // 日期改变
      getDataChange(val) {
        let start = null , end = null;
        if(val) {
          if(this.isYearDateRang) {
            start = val;
            end = val;
          }else {
            start = val[0];
            end = val[1];
          }
        }
        this.formData.start = start;
        this.formData.end = end;
        this.getTableData();
      },
      // 账户改变
      accountChange(e) {
        if(e.length) {
          let isHaveAll = false,indexs=0;
          e.forEach((i,index)=>{
            if(i == 1) {
              indexs = index;
              isHaveAll = true;
            }
          })
          if(isHaveAll) {  // 有全部选项
            if(indexs === e.length-1) { // 如果全部在最后面  则删除其他
              this.formData.fkJournalAccountIds = ["1"]
            }else {
              this.formData.fkJournalAccountIds.splice(indexs,1)
            }
          }
        }else {
          this.formData.fkJournalAccountIds = ["1"];
        }
        this.getTableData();
      },
      // 查询所有账户
      getAllAccount(){
        this.$http.post('journal/getInventoryAccounts',{}).then(res=>{
          if(res && res.data.code == '1'){
            let datas = res.data.data;
            this.allAccountList = this.$lodash.cloneDeep(datas);
            if(this.allAccountList.length) {
              this.formData.fkJournalAccountIds.push(this.allAccountList[0].id)
              this.getTableData()
            };

          }
        }).catch(e=>{

        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .inventory_wrapper {
    height: calc(100% - 75px);
    &-tableList {
      margin-top: 20px;
      height: calc(100% - 53px);
      /deep/.i-tableRow-total {
        background: #eff9f6;
      }
      &-textLeft {
        display: inline-block;
        width: 100%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-textRight {
        display: inline-block;
        width: 100%;
        text-align: right;
      }
      &-editIcon {
        color: #FF2626;
        font-size: 12px;
        border: 1px solid #FF2626;
        border-radius: 50%;
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        position: absolute;
        right: 2px;
        top: 9px;
        cursor: pointer;
        user-select: none;
      }
      &-operation {
        span {
          cursor: pointer;
          padding: 2px 4px;
        }
        &-edit {
          color: #409eff;
        }
        &-save {
          color: #409eff;
        }
        &-cancal {
          color: #666;
        }
      }
    }
    &-title {
      color: #313242;
      font-size: 18px;
      font-weight: 500;
    }
    &-form {
      flex: 1;
      margin-left: 10px;
      &-accAount {
       /deep/ .el-tag__close {
          display: none;
        }
      }
      &-date {
        width: 294px;
        margin-left: 15px;
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/inventory.vue